<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="structure-nxt"> </p>
<p class="body-paragraph-white">Dear reader, I don’t know where you are in your life’s journey, but I’m pretty sure you will find many quotes in <span class="BROTHERregularitalic">Hey! It’s Your Day</span><span class="CharOverride-16"> </span>that will inspire you every day. You have a whole book ahead of you, so I’ll close with a short, affirming quote, which has guided me for many years:</p>
<p class="Yellow_Quote">Nothing is worth more than this<span class="noBreak"> </span>day.</p>
<p class="QuoteAuthor_Yellow">—Johann Wolfgang von Goethe</p>
<p class="White_Quote ParaOverride-5"><span class="CharOverride-17">June</span><span class="noBreak CharOverride-17"> </span><span class="CharOverride-17">Cotner</span></p>
<p class="body-paragraph-white ParaOverride-6"><a href="http://www.junecotner.com" target="_blank">www.junecotner.com</a> | <a href="mailto:june@junecotner.com">june@junecotner.com</a></p>
<p class="body-paragraph-white ParaOverride-7">Facebook: @June.Cotner.Books (author page)<br/>LinkedIn: <a href="http://www.linkedin.com/in/junecotner" target="_blank">www.linkedin.com/in/junecotner</a><br/>Instagram: @JuneCotner<br/>Twitter: @JuneCotner</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 97816425039446.vue?4312d8c6